import { z } from 'zod';
/** Corps HTTP déjà désérialisé : un objet JSON, ni tableau ni primitive. */
const jsonObjectPayload = z.record(z.unknown());
// Renommer une clé de schéma d'écriture casse les clients déjà chargés : un
// back-office resté ouvert sur l'ancien bundle JS continue d'envoyer l'ancien nom
// pendant toute la durée de vie de son onglet. On accepte donc l'ancienne clé en
// alias, normalisée vers la nouvelle *avant* la validation — le schéma lui-même ne
// connaît que le nouveau nom, et son type de sortie reste inchangé (contrairement à
// un `.transform()`, qui rendrait la clé obligatoire).
//
// Le renommage est livré collé à son schéma plutôt qu'en fonction libre : le corps
// HTTP n'est décodé qu'ici, à l'entrée de la validation, et aucun appelant ne se
// retrouve à manipuler une charge utile encore non décodée.
export const withRenamedDeprecatedKey = (schema, deprecatedKey, currentKey) => z.preprocess((value) => {
    // Un tableau, `null` ou une primitive ne portent aucune clé à renommer : ils
    // repartent tels quels, et c'est le schéma en aval qui les rejettera.
    const payload = jsonObjectPayload.safeParse(value);
    if (!payload.success)
        return value;
    const { [deprecatedKey]: deprecated, ...rest } = payload.data;
    if (deprecated === undefined)
        return rest;
    return rest[currentKey] === undefined ? { ...rest, [currentKey]: deprecated } : rest;
}, schema);
